














































import Vue from 'vue';

import { Job } from '@/core/entity';

import Step1 from './Step1.vue';
import Step2 from './Step2.vue';

export default Vue.extend({
  components: {
    'step-1': Step1,
    'step-2': Step2,
  },

  data() {
    return {
      current: 0,
      steps: [
        {
          title: 'Setup',
        },
        {
          title: 'Products & Outlets',
        },
      ],
      loading: false,

      clientId: undefined as string | undefined,
      csvFile: undefined as File | undefined,
      date: undefined as string | undefined,
      isPriority: undefined as boolean | undefined,
      lastJobId: undefined as string | undefined,
      note: undefined as string | undefined,
      outlets: [] as string[],
      projectId: undefined as string | undefined,
    };
  },

  methods: {
    onBack() {
      this.current = this.current - 1;
    },

    handleCreate() {
      this.$coreApp.job.create(
        {
          projectId: this.projectId!,
          jobDate: this.date!,
          note: this.note,
          outlets: this.outlets,
          prevJob: this.lastJobId,
          priority: this.isPriority ? 10 : 1,
        },
        this.csvFile || null,
        this.presenter('Job created.', 'Unable to create job:'),
      );
    },

    presenter(success: string, failure: string) {
      return (err: Error | null, result: Job | null, loading: boolean) => {
        this.loading = loading;
        if (err) {
          this.$message.error(`${failure} ${err.message}`);
        } else if (result !== null) {
          this.$message.success(success);

          this.$router.back();
        }
      };
    },

    showConfirm(val: any) {
      if (val.lastJobId) {
        this.lastJobId = val.lastJobId;
      } else {
        this.csvFile = val.csv;
        this.outlets = val.outlets;
      }

      this.$confirm({
        title: 'Create this job?',
        content: `I've completed all fields and want to create this job.`,
        onOk: this.handleCreate,
      });
    },

    toStep2(val: any) {
      this.clientId = val.clientId;
      this.date = val.date.format('YYYY-MM-DD');
      this.isPriority = val.isPriority;
      this.note = val.note;
      this.projectId = val.projectId;

      this.current = this.current + 1;
    },
  },
});
